// 展示不同的消息
export function showMessage(msg,type) {
  if (type=='success'){
    this.$message({
      message: msg,
      type: 'success'
    });
  }else if (type=='fail'){
    this.$message.error(msg);
  }else if (type=='warning'){
    this.$message({
      message: msg,
      type: 'warning'
    })
  }
}






